import { Component, OnInit } from '@angular/core';
import { localStorageKeys } from '../../../Models/configurations';
import { SecureStorageService } from './../../../Services/secure-storage.service';

@Component({
  selector: 'app-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.css']
})
export class SubHeaderComponent implements OnInit {

  // customerDetail: any;
  dealerDetail: any;
  countries: any;
  languageModel: any;
  currentLang: string;
  selectedLanguageText: string;
  selectedLanguageFlag: string;
  selectedLangExpireDate = new Date();
  isLanguageFlag:boolean=false;
  constructor(
    private readonly secureStorageService: SecureStorageService,
  ) {
    // This is intentional
  }

  public verificationDetails(): void {
    if (typeof (this.secureStorageService.getKeyData(localStorageKeys.checkingModule)) !== 'undefined') {
      this.dealerDetail = this.secureStorageService.getKeyData(localStorageKeys.checkingModule).dealerDetail;
    }
  }

  ngOnInit(): void {
    this.verificationDetails();
  }
}
